"use client";

import { Info } from "lucide-react";
import type { ReactNode } from "react";

import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

interface InfoTooltipProps {
  content: ReactNode;
  className?: string;
  iconClassName?: string;
}

export function InfoTooltip({ content, className, iconClassName }: InfoTooltipProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn("shrink-0 cursor-pointer", className)}
          aria-label="Info"
        >
          <Info className={cn("size-3.5 text-muted-foreground", iconClassName)} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-52 p-2 text-sm" side="top" align="start">
        {content}
      </PopoverContent>
    </Popover>
  );
}
